/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloColumnas from 'Infotrack@Modelos/smartStock/columnas';
import IColumnas from 'Infotrack@Modelos/smartStock/columnas/entidades/columnas';
import IFiltrosColumnas from 'Infotrack@Modelos/smartStock/columnas/entidades/filtrosColumnas';

export default class ControladorModeloColumnas {
    private modeloColumnas: ModeloColumnas;
    constructor() {
        this.modeloColumnas = new ModeloColumnas();
    }

    public consultarColumnas() {
        return this.modeloColumnas.consultarColumnas().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearColumnas(columnas: IColumnas) {
        await this.modeloColumnas.crearColumnas(columnas);
    }

    public async editarColumnas(columnas: IColumnas) {
        await this.modeloColumnas.editarColumnas(columnas);
    }
    public async eliminarColumnas(columnas: IColumnas) {
        await this.modeloColumnas.eliminarColumnas(columnas);
    }

    public validarEntidad(columnas: IColumnas): boolean {
        if (columnas.DescripcionColumna === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarColumnasPorFiltro(columnas: Partial<IFiltrosColumnas>) {
      return (await this.modeloColumnas.consultarListaColumnasPorFiltro(columnas)).data.Entidades;
    }
}
